//api.js
import file from "@/assets/api/file.js";
import user from "@/assets/api/user.js";
import order from "@/assets/api/order.js";
import goods from "@/assets/api/goods.js";
import view from "@/assets/api/view.js";
import common from "@/assets/api/common.js";
import active from "@/assets/api/active.js";
import notice from "@/assets/api/notice.js";
export default {
    file,
    user,
    order,
    goods,
    view,
    common,
    notice,
    active
}